export interface WhatsNewRuleForm {
    WhatsNewInformationsId: number,    
    WhatsNewHeaderDe: string,
    WhatsNewHeaderEn: string,
    WhatsNewHeaderCn: string,
} 

export const EmptyWhatsNewRuleForm = {
    WhatsNewInformationsId: 0,    
    WhatsNewHeaderDe: "",
    WhatsNewHeaderEn: "",
    WhatsNewHeaderCn: "",    
}